/* B2B FAQ accordion. CSS owns the open/close animation (grid-rows); this only
   toggles the open class and aria-expanded, and optionally keeps a single item
   open at a time. */
(function () {
  'use strict';

  function initFaq(root) {
    if (root.dataset.b2bFaqReady === 'true') return;
    root.dataset.b2bFaqReady = 'true';

    var singleOpen = root.hasAttribute('data-single-open');
    var items = root.querySelectorAll('[data-faq-item]');

    function setOpen(item, open) {
      item.classList.toggle('frido-b2b-faq__item--open', open);
      var toggle = item.querySelector('[data-faq-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('frido-b2b-faq__item--open');

        if (singleOpen && !isOpen) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, !isOpen);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-b2b-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
